<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-8">
    <div class="flex-0 w-full">
        <dl class="w-full grid grid-cols-1 gap-5 sm:grid-cols-3">
            <div class="overflow-hidden rounded-lg px-4 py-4 shadow-sm inset-ring inset-ring-white/10">
                <dt class="truncate text-sm font-medium text-secondary">Current Balance</dt>
                <dd class="mt-1 text-3xl font-semibold tracking-tight text-primary">{{ walletService.currentBalance() |
                    currency:walletService.currencyCode()?.toUpperCase() }}</dd>
            </div>
            <div class="overflow-hidden rounded-lg px-4 py-4 shadow-sm inset-ring inset-ring-white/10">
                <dt class="truncate text-sm font-medium text-secondary">Available Balance</dt>
                <dd class="mt-1 text-3xl font-semibold tracking-tight text-primary">{{ walletService.availableBalance()
                    | currency:walletService.currencyCode()?.toUpperCase() }}</dd>
            </div>
            <div (click)="openTopUpDrawer()" data-guide-id="wallet.openTopUp"
                class="flex rounded-lg shadow-sm inset-ring inset-ring-white/10 hover:cursor-pointer hover:bg-primary/10 hover:shadow-md">
                <div
                    class="flex w-16 shrink-0 items-center justify-center rounded-l-md bg-primary text-sm font-medium text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-8 text-white">
                        <path d="M12 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5" />
                        <path d="M18 12h.01" />
                        <path d="M19 22v-6" />
                        <path d="m22 19-3-3-3 3" />
                        <path d="M6 12h.01" />
                        <circle cx="12" cy="12" r="2" />
                    </svg>
                </div>
                <div
                    class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-white/10">
                    <div class="flex-1 truncate px-4 py-4 text-sm">
                        <a href="#" class="font-medium text-primary hover:text-gray-200">Top-Up Wallet</a>
                        <p class="text-secondary">Add funds to hire creators</p>
                    </div>
                    <div class="shrink-0 pr-2">
                        <button type="button"
                            class="inline-flex size-8 items-center justify-center rounded-full text-gray-400 hover:text-primary focus:outline-2 focus:outline-offset-2 focus:outline-white">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5">
                                <path
                                    d="M11 9a1 1 0 0 0 1-1V5.061a1 1 0 0 1 1.811-.75l6.836 6.836a1.207 1.207 0 0 1 0 1.707l-6.836 6.835a1 1 0 0 1-1.811-.75V16a1 1 0 0 0-1-1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </dl>
    </div>


    <!-- Table Section -->
    <div class="h-full flex-1 flex flex-col items-center justify-center w-full overflow-hidden">
        <div class="data-table-wrapper h-full w-full flex flex-col overflow-hidden">
            <!-- Filters -->
            <div
                class="shrink-0 flex flex-row items-end justify-between w-full gap-4 px-4 py-4 border-b border-zinc-200 dark:border-zinc-800">

        <!-- Search Transactions -->
        <div class="flex flex-row items-end justify-start gap-2">
            <div class="grid grid-cols-1 gap-2">
                <label class="flex flex-col gap-1 justify-end">
                    <span class="text-xs font-semibold uppercase tracking-wide text-slate-500">Search Transactions</span>
                    <div class="relative">
                        <div class="grid grid-cols-1">
                            <input [formField]="searchQueryForm.query" id="wallet-search" type="text"
                                placeholder="Search by creator, brand, or brief name" class="input-icon text-primary" />
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 sm:size-4">
                                <path d="m21 21-4.34-4.34" />
                                <circle cx="11" cy="11" r="8" />
                            </svg>
                        </div>
                    </div>
                </label>
            </div>
        </div>
        <!-- Search Transactions - END -->

        <!-- Table View -->
        <div class="flex flex-row items-end justify-start gap-2">
            <div class="grid grid-cols-1 gap-2">
                <label class="flex flex-col gap-1 justify-end">
                    <span class="text-xs font-semibold uppercase tracking-wide text-slate-500">Payments in / out</span>
                    <div class="relative">
                        <nav aria-label="Tabs" class="flex space-x-4">
                            <a (click)="activeStatementTab.set('all')"
                                class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                                [class]="getStatementTabClass('all')">All</a>
                            <a (click)="activeStatementTab.set('all-creators')"
                                class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                                [class]="getStatementTabClass('all-creators')">Creator Hires</a>
                            <a (click)="activeStatementTab.set('topups')"
                                class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                                [class]="getStatementTabClass('topups')">Wallet Top-Ups</a>
                        </nav>
                    </div>
                </label>
            </div>
        </div>
        <!-- Table View - END -->

        <!-- Download Filters -->
        <div class="flex flex-row items-end justify-end gap-2">
            <div class="grid grid-cols-1 gap-2 sm:grid-cols-3">
                <label class="flex flex-col gap-1 justify-end">
                    <span class="text-xs font-semibold uppercase tracking-wide text-slate-500">From</span>
                    <div class="relative">
                        <input type="date" [value]="exportStartDate()" (input)="onExportStartDateInput($event)"
                            (change)="onExportStartDateInput($event)"
                            class="wallet-date-input relative w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-sm text-gray-900 dark:border-zinc-600 dark:bg-zinc-900 dark:text-gray-100" />
                        <span
                            class="pointer-events-none absolute inset-y-0 right-2.5 flex items-center text-slate-400 dark:text-slate-500"
                            aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                                class="size-5 shrink-0">
                                <path d="M8 2v4M16 2v4" />
                                <rect width="18" height="18" x="3" y="4" rx="2" />
                                <path d="M3 10h18" />
                            </svg>
                        </span>
                    </div>
                </label>

                <label class="flex flex-col gap-1 justify-end">
                    <span class="text-xs font-semibold uppercase tracking-wide text-slate-500">To</span>
                    <div class="relative">
                        <input type="date" [value]="exportEndDate()" (input)="onExportEndDateInput($event)"
                            (change)="onExportEndDateInput($event)"
                            class="wallet-date-input relative w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-sm text-gray-900 dark:border-zinc-600 dark:bg-zinc-900 dark:text-gray-100" />
                        <span
                            class="pointer-events-none absolute inset-y-0 right-2.5 flex items-center text-slate-400 dark:text-slate-500"
                            aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                                class="size-5 shrink-0">
                                <path d="M8 2v4M16 2v4" />
                                <rect width="18" height="18" x="3" y="4" rx="2" />
                                <path d="M3 10h18" />
                            </svg>
                        </span>
                    </div>
                </label>

                <div class="flex flex-col gap-1 justify-end">
                    <label for="wallet-payment-state-select"
                        class="text-xs font-semibold uppercase tracking-wide text-slate-500">Payment state</label>
                    <el-select id="wallet-payment-state-select" name="paymentState" [value]="paymentStateFilter()"
                        class="block">
                        <button type="button"
                            class="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:focus-visible:outline-primary">
                            <el-selectedcontent class="col-start-1 row-start-1 truncate pr-6">{{
                                paymentStateFilterLabel() }}</el-selectedcontent>
                            <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4 dark:text-gray-400">
                                <path
                                    d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                        </button>

                        <el-options anchor="bottom start" popover
                            class="max-h-60 w-(--button-width) overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline-1 outline-black/5 [--anchor-gap:--spacing(1)] data-leave:transition data-leave:transition-discrete data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10">
                            <el-option value="both" (click)="onPaymentStateFilterSelected('both')"
                                class="group/option relative block cursor-default py-2 pr-9 pl-3 text-gray-900 select-none focus:bg-primary focus:text-white focus:outline-hidden dark:text-white dark:focus:bg-primary">
                                <span
                                    class="block truncate font-normal group-aria-selected/option:font-semibold">Both</span>
                                <span
                                    class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-white in-[el-selectedcontent]:hidden">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="size-5">
                                        <path
                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </span>
                            </el-option>
                            <el-option value="reserved" (click)="onPaymentStateFilterSelected('reserved')"
                                class="group/option relative block cursor-default py-2 pr-9 pl-3 text-gray-900 select-none focus:bg-primary focus:text-white focus:outline-hidden dark:text-white dark:focus:bg-primary">
                                <span
                                    class="block truncate font-normal group-aria-selected/option:font-semibold">Reserved</span>
                                <span
                                    class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-white in-[el-selectedcontent]:hidden">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="size-5">
                                        <path
                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </span>
                            </el-option>
                            <el-option value="released" (click)="onPaymentStateFilterSelected('released')"
                                class="group/option relative block cursor-default py-2 pr-9 pl-3 text-gray-900 select-none focus:bg-primary focus:text-white focus:outline-hidden dark:text-white dark:focus:bg-primary">
                                <span
                                    class="block truncate font-normal group-aria-selected/option:font-semibold">Released</span>
                                <span
                                    class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-white in-[el-selectedcontent]:hidden">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="size-5">
                                        <path
                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </span>
                            </el-option>
                        </el-options>
                    </el-select>
                </div>
            </div>

            <div class="inline-flex rounded-md">
                <button type="button" (click)="showDownloadOptions.set(!showDownloadOptions())"
                    class="relative inline-flex items-center rounded-l-md bg-primary dark:bg-primary px-3 py-2 text-sm font-semibold text-white inset-ring-1 inset-ring-zinc-300 dark:inset-ring-white/10 hover:bg-primary/90 dark:hover:bg-primary/90 focus:z-10 focus:outline-hidden">Download</button>
                <el-dropdown [open]="showDownloadOptions()" class="relative -ml-px block">
                    <button (click)="showDownloadOptions.set(!showDownloadOptions())"
                        class="relative inline-flex items-center rounded-r-md bg-primary dark:bg-primary px-2 py-2 text-white inset-ring-1 inset-ring-zinc-300 dark:inset-ring-white/10 hover:bg-primary/90 dark:hover:bg-primary/90 focus:z-10 cursor-pointer">
                        <span class="sr-only">Open options</span>
                        <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5">
                            <path
                                d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                                clip-rule="evenodd" fill-rule="evenodd" />
                        </svg>
                    </button>
                    <el-menu anchor="bottom end" popover [open]="showDownloadOptions()"
                        class="ml-1 w-56 origin-top-right rounded-md dark:bg-gray-800 bg-gray-100 outline-1 -outline-offset-1 outline-white/10 transition transition-discrete [--anchor-gap:--spacing(2)] data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in shadow-md">
                        <div class="py-1">

                            <a (click)="downloadFilteredStatementCsv()"
                                class="w-full px-4 py-2 text-sm text-primary focus:bg-white/5 focus:text-primary focus:outline-hidden cursor-pointer inline-flex items-center gap-x-1.5 dark:hover:bg-primary/90 hover:bg-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-4">
                                    <path d="M12 3v18" />
                                    <rect width="18" height="18" x="3" y="3" rx="2" />
                                    <path d="M3 9h18" />
                                    <path d="M3 15h18" />
                                </svg>
                                Download CSV</a>

                            <a (click)="downloadFilteredStatementPdf()"
                                class="w-full px-4 py-2 text-sm text-primary focus:bg-white/5 focus:text-primary focus:outline-hidden cursor-pointer inline-flex items-center gap-x-1.5 dark:hover:bg-primary/90 hover:bg-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-4">
                                    <path
                                        d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                                    <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                    <path d="M10 9H8" />
                                    <path d="M16 13H8" />
                                    <path d="M16 17H8" />
                                </svg>
                                Download PDF</a>

                        </div>
                    </el-menu>
                </el-dropdown>
            </div>
        </div>
        <!-- Download Filters - END -->
            </div>
            <!-- Filters - END-->

            <div class="flex-1 min-h-0 overflow-hidden">
        @switch (activeStatementTab()) {
        @case ('all') {
        <div class="w-full h-full flex flex-col overflow-hidden">

            <div class="flow-root flex-1 min-h-0 overflow-hidden">
                <div class="overflow-x-auto h-full">
                    <div class="inline-block min-w-full align-middle h-full">
                        <div class="h-full flex flex-col overflow-hidden">
                            <div class="overflow-y-auto flex-1 min-h-0 scrollbar-hide dark:bg-gray-800/50">

                                <div class="sm:flex sm:items-center px-4 pt-2 bg-muted sticky top-0 z-10">
                                    <div class="sm:flex-auto">
                                        <h1 class="text-sm font-semibold text-gray-900 dark:text-white">All transactions</h1>
                                        <p class="text-xs text-gray-700 dark:text-gray-300">Top-ups, creator hires, and
                                            adjustments. Green is money in, red is money out.</p>
                                    </div>
                                </div>

                                <table class="data-table min-w-full [&_tbody_td]:!py-5">
                                    <thead class="sticky top-0 z-10">
                                        <tr>
                                            <th scope="col"
                                                class="py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">
                                                Date</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                Type</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                Details</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                Amount</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                Status</th>
                                            <th scope="col" class="py-3.5 text-right text-sm pr-4 pl-3 sm:pr-0">
                                                Download
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @if (loadingState() === 'loading' || loadingState() === 'idle') {
                                        @for (row of allCreatorsSkeletonRows; track row) {
                                        <tr class="border-b border-gray-200/90 dark:border-zinc-600/50">
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-4 w-20" aria-hidden="true"></div>
                                            </td>
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-6 w-24" aria-hidden="true"></div>
                                            </td>
                                            <td class="py-3 pr-4">
                                                <div class="flex items-center gap-3" aria-hidden="true">
                                                    <div class="wallet-skeleton wallet-skeleton--pill size-8 shrink-0">
                                                    </div>
                                                    <div class="wallet-skeleton h-4 w-40"></div>
                                                </div>
                                            </td>
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-4 w-16" aria-hidden="true"></div>
                                            </td>
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-6 w-16" aria-hidden="true"></div>
                                            </td>
                                            <td class="py-3 text-right">
                                                <div class="wallet-skeleton h-4 w-16" aria-hidden="true"></div>
                                            </td>
                                        </tr>
                                        }
                                        } @else {
                                        @for (transaction of filteredAllTransactions(); track transaction.id) {
                                        <tr class="border-b border-gray-100 text-gray-700">
                                            <td class="py-3 pr-4">{{ getStatementDateDisplay(transaction) | date: 'dd MMM yy' }}</td>
                                            <td class="py-3 pr-4">
                                                <span [class]="getTransactionKindBadgeClass(transaction)">
                                                    {{ getTransactionKindLabel(transaction) }}
                                                </span>
                                            </td>
                                            <td class="py-3 pr-4">
                                                @if (getTransactionKind(transaction) === 'hire') {
                                                <div class="flex items-center gap-3">
                                                    <img [src]="getCreatorPhotoUrl(transaction)" alt=""
                                                        class="size-8 shrink-0 rounded-full object-cover bg-gray-100 dark:bg-zinc-700" />
                                                    <div class="min-w-0">
                                                        <p class="m-0 font-medium text-primary">{{ getCreatorName(transaction) }}</p>
                                                        @if (getBrandName(transaction); as brand) {
                                                          @if (brand !== '-') {
                                                            <p class="m-0 mt-0.5 truncate text-xs text-secondary">{{ brand }}</p>
                                                          }
                                                        }
                                                        @if (getBriefTitle(transaction); as brief) {
                                                          @if (brief !== '-') {
                                                            <p class="m-0 truncate text-xs text-secondary">{{ brief }}</p>
                                                          }
                                                        }
                                                    </div>
                                                </div>
                                                } @else {
                                                <p class="m-0">{{ getTransactionDetails(transaction) }}</p>
                                                }
                                            </td>
                                            <td class="py-3 pr-4 font-semibold"
                                                [class.text-red-700]="transaction.amount < 0"
                                                [class.text-emerald-700]="transaction.amount > 0">
                                                {{ getSignedAmountPounds(transaction) | currency: getCurrencyCode(transaction) }}
                                            </td>
                                            <td class="py-3 pr-4">
                                                @if (getTransactionKind(transaction) === 'hire') {
                                                <span
                                                    [class]="transaction.reservedForPurchase
                                                              ? 'rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-700'
                                                              : 'rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700'">
                                                    {{ getStatementStatusLabel(transaction) }}
                                                </span>
                                                } @else {
                                                <p class="m-0 text-xs text-slate-400">-</p>
                                                }
                                            </td>
                                            <td class="py-3 text-right">
                                                @if (getTransactionKind(transaction) === 'topup') {
                                                @if (invoicesDownloading().indexOf(transaction.id) > -1) {
                                                <svg aria-hidden="true"
                                                    class="mx-auto w-4 h-4 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                                                    viewBox="0 0 100 101" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                        fill="currentColor" />
                                                    <path
                                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                        fill="currentFill" />
                                                </svg>
                                                } @else {
                                                <button type="button" (click)="downloadTopupReceipt(transaction)"
                                                    class="text-sm font-medium text-accent hover:text-primary/85">
                                                    Download
                                                </button>
                                                }
                                                } @else if (getTransactionKind(transaction) === 'hire' && !transaction.reservedForPurchase) {
                                                @if (invoicesDownloading().indexOf(transaction.id) > -1) {
                                                <svg aria-hidden="true"
                                                    class="mx-auto w-4 h-4 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                                                    viewBox="0 0 100 101" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                        fill="currentColor" />
                                                    <path
                                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                        fill="currentFill" />
                                                </svg>
                                                } @else {
                                                <button type="button" (click)="createInvoice(transaction)"
                                                    class="text-sm font-medium text-accent hover:text-primary/85">
                                                    Download
                                                </button>
                                                }
                                                } @else {
                                                <p class="m-0 text-xs text-slate-400">-</p>
                                                }
                                                @if (invoiceErrorsById()[transaction.id]) {
                                                <p class="mt-1 text-xs text-amber-700">{{
                                                    invoiceErrorsById()[transaction.id] }}</p>
                                                }
                                            </td>
                                        </tr>
                                        }
                                        }
                                    </tbody>
                                </table>

                                @if (loadingState() === 'loaded' && filteredAllTransactions().length === 0) {
                                <app-empty-state class="w-full py-12" title="No transactions found"
                                    description="No wallet movements match your current search or date range. Try adjusting your filters." />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
        @case ('all-creators') {
        <div class="w-full h-full flex flex-col overflow-hidden">

            <div class="flow-root flex-1 min-h-0 overflow-hidden">
                <div class="overflow-x-auto h-full">
                    <div class="inline-block min-w-full align-middle h-full">
                        <div class="h-full flex flex-col overflow-hidden">
                            <div class="overflow-y-auto flex-1 min-h-0 scrollbar-hide dark:bg-gray-800/50">

                                <div class="sm:flex sm:items-center px-4 pt-2 bg-muted sticky top-0 z-10">
                                    <div class="sm:flex-auto">
                                        <h1 class="text-sm font-semibold text-gray-900 dark:text-white">All Hires</h1>
                                        <p class="text-xs text-gray-700 dark:text-gray-300">All creator hires are shown.
                                            The list is limited by the date range and payment state filters.</p>
                                    </div>
                                </div>

                                <table class="data-table min-w-full [&_tbody_td]:!py-5">
                                    <thead class="sticky top-0 z-10">
                                        <tr>
                                            <th scope="col"
                                                class="py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">
                                                Date</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                Creator</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                Brand</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                Brief</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                Cost</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                Tax</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                Net</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                Status</th>
                                            <th scope="col" class="py-3.5 text-right text-sm pr-4 pl-3 sm:pr-0">
                                                Download
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        @if (loadingState() === 'loading' || loadingState() === 'idle') {
                                        @for (row of allCreatorsSkeletonRows; track row) {
                                        <tr class="border-b border-gray-200/90 dark:border-zinc-600/50">
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-4 w-20" aria-hidden="true"></div>
                                            </td>
                                            <td class="py-3 pr-4">
                                                <div class="flex items-center gap-3" aria-hidden="true">
                                                    <div class="wallet-skeleton wallet-skeleton--pill size-8 shrink-0">
                                                    </div>
                                                    <div class="wallet-skeleton h-4 w-24"></div>
                                                </div>
                                            </td>
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-4 w-28" aria-hidden="true"></div>
                                            </td>
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-4 w-40" aria-hidden="true"></div>
                                            </td>
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-4 w-12" aria-hidden="true"></div>
                                            </td>
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-4 w-16" aria-hidden="true"></div>
                                            </td>
                                            @if (showTaxColumn()) {
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-4 w-16" aria-hidden="true"></div>
                                            </td>
                                            }
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-4 w-16" aria-hidden="true"></div>
                                            </td>
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton wallet-skeleton--pill h-6 w-[4.5rem]"
                                                    aria-hidden="true"></div>
                                            </td>
                                            <td class="py-3 text-right">
                                                <div class="wallet-skeleton h-4 w-16" aria-hidden="true"></div>
                                            </td>
                                        </tr>
                                        }
                                        } @else {
                                        @for (transaction of filteredCreatorTransactions(); track transaction.id) {
                                        <tr class="border-b border-gray-100 text-gray-700">
                                            <td class="py-3 pr-4">{{ getStatementDateDisplay(transaction) | date: 'dd
                                                MMM yy' }}</td>
                                            <td class="py-3 pr-4">
                                                <div class="flex items-center gap-3">
                                                    <img [src]="getCreatorPhotoUrl(transaction)" alt=""
                                                        class="size-8 shrink-0 rounded-full object-cover bg-gray-100 dark:bg-zinc-700" />
                                                    <p class="m-0">{{ getCreatorName(transaction) }}</p>
                                                </div>
                                            </td>
                                            <td class="py-3 pr-4 max-w-40 truncate"
                                                [title]="getBrandName(transaction)">{{ getBrandName(transaction) }}
                                            </td>
                                            <td class="py-3 pr-4 max-w-80 truncate"
                                                [title]="getBriefTitle(transaction)">{{ getBriefTitle(transaction) }}
                                            </td>
                                            <!-- <td class="py-3 pr-4">{{ getCurrencyCode(transaction) }}</td> -->
                                            <td class="py-3 pr-4">{{ getAbsoluteAmountPennies(transaction) | currency:
                                                getCurrencyCode(transaction) }}</td>
                                            @if (showTaxColumn()) {
                                            <td class="py-3 pr-4">{{
                                                getTaxAmountPennies(transaction) | currency:
                                                getCurrencyCode(transaction) }}</td>
                                            }
                                            <td class="py-3 pr-4 font-semibold">{{
                                                getNetAmountPennies(transaction) | currency:
                                                getCurrencyCode(transaction) }}</td>
                                            <td class="py-3 pr-4">
                                                <span
                                                    [class]="transaction.reservedForPurchase
                                                              ? 'rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-700'
                                                              : 'rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700'">
                                                    {{ getStatementStatusLabel(transaction) }}
                                                </span>
                                            </td>
                                            <td class="py-3 text-right">
                                                @if (!transaction.reservedForPurchase) {
                                                @if (invoicesDownloading().indexOf(transaction.id) > -1) {
                                                <svg aria-hidden="true"
                                                    class="mx-auto w-4 h-4 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                                                    viewBox="0 0 100 101" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                        fill="currentColor" />
                                                    <path
                                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                        fill="currentFill" />
                                                </svg>
                                                } @else {
                                                <button type="button" (click)="createInvoice(transaction)"
                                                    class="text-sm font-medium text-accent hover:text-primary/85">
                                                    Download
                                                </button>
                                                }
                                                @if (invoiceErrorsById()[transaction.id]) {
                                                <p class="mt-1 text-[11px] text-amber-700">{{
                                                    invoiceErrorsById()[transaction.id] }}</p>
                                                }
                                                } @else {
                                                <span class="text-xs text-slate-400">-</span>
                                                }
                                            </td>
                                        </tr>
                                        }
                                        }
                                    </tbody>
                                </table>

                                @if (loadingState() === 'loaded' && filteredCreatorTransactions().length === 0) {
                                <app-empty-state class="w-full py-12" title="No transactions found"
                                    description="No creator hires match your current search, date range or payment-state filters. Try adjusting them." />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        } @case ('topups') {
        <div class="w-full h-full flex flex-col overflow-hidden">

            <div class="flow-root flex-1 min-h-0 overflow-hidden">
                <div class="overflow-x-auto h-full">
                    <div class="inline-block min-w-full align-middle h-full">
                        <div class="h-full flex flex-col overflow-hidden">
                            <div class="overflow-y-auto flex-1 min-h-0 scrollbar-hide dark:bg-gray-800/50">

                                <div class="sm:flex sm:items-center px-4 pt-2 bg-muted sticky top-0 z-10">
                                    <div class="sm:flex-auto">
                                        <h1 class="text-sm font-semibold text-gray-900 dark:text-white">All Wallet
                                            Top-Ups</h1>
                                        <p class="text-xs text-gray-700 dark:text-gray-300">All the deposits you and
                                            your team have made to your SHOUT wallet.</p>
                                    </div>
                                </div>

                                <table class="data-table min-w-full [&_tbody_td]:!py-5">
                                    <thead class="sticky top-0 z-10">
                                        <tr>
                                            <th scope="col"
                                                class="py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">
                                                Date</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                User</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                Currency</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                Amount</th>
                                            <th scope="col" class="py-3.5 text-right text-sm pr-4 pl-3 sm:pr-0">
                                                Download
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        @if (loadingState() === 'loading' || loadingState() === 'idle') {
                                        @for (row of allCreatorsSkeletonRows; track row) {
                                        <tr class="border-b border-gray-200/90 dark:border-zinc-600/50">
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-4 w-20" aria-hidden="true"></div>
                                            </td>
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-4 w-24" aria-hidden="true"></div>
                                            </td>
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-4 w-40" aria-hidden="true"></div>
                                            </td>
                                            <td class="py-3 pr-4">
                                                <div class="wallet-skeleton h-4 w-12" aria-hidden="true"></div>
                                            </td>
                                            <td class="py-3 text-right">
                                                <div class="wallet-skeleton h-4 w-16" aria-hidden="true"></div>
                                            </td>
                                        </tr>
                                        }
                                        } @else {
                                        @for (transaction of filteredTopupTransactions(); track transaction.id) {
                                        <tr class="border-b border-gray-100 text-gray-700">
                                            <td class="py-3 pr-4">{{ getStatementDateDisplay(transaction) | date: 'dd MMM yy' }}</td>
                                            <td class="py-3 pr-4">{{ getTopupAddedBy(transaction) }}</td>
                                            <td class="py-3 pr-4">{{ getCurrencyCode(transaction) }}</td>
                                            <td class="py-3 pr-4">{{ transaction.amount / 100 | currency: getCurrencyCode(transaction) }}</td>
                                            <td class="py-3 text-right">
                                                @if (invoicesDownloading().indexOf(transaction.id) > -1) {
                                                <svg aria-hidden="true"
                                                    class="mx-auto w-4 h-4 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                                                    viewBox="0 0 100 101" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                        fill="currentColor" />
                                                    <path
                                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                        fill="currentFill" />
                                                </svg>
                                                } @else {
                                                <button type="button" (click)="downloadTopupReceipt(transaction)"
                                                    class="text-sm font-medium text-accent hover:text-primary/85">
                                                    Download
                                                </button>
                                                }
                                                @if (invoiceErrorsById()[transaction.id]) {
                                                <p class="mt-1 text-[11px] text-amber-700">{{
                                                    invoiceErrorsById()[transaction.id] }}</p>
                                                }
                                            </td>
                                        </tr>
                                        }
                                        }
                                    </tbody>
                                </table>

                                @if (loadingState() === 'loaded' && filteredTopupTransactions().length === 0) {
                                <app-empty-state class="w-full py-12" title="No top-ups found"
                                    description="No wallet top-ups match your current search or date range. Try adjusting your filters." />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
        }
            </div>
        </div>
    </div>
    <!-- Table Section - END -->

</div>